import { render, staticRenderFns } from "./DocumentDetailList13.vue?vue&type=template&id=568275e4&scoped=true"
import script from "./DocumentDetailList13.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList13.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailList13.vue?vue&type=style&index=0&id=568275e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568275e4",
  null
  
)

export default component.exports